export default "__VITE_ASSET__Bpwe5p4N__"